import { Stats } from "../../stats/stats";

export class responseGetStats {
    stats:Stats;
    constructor(stats) {
        this.stats = new Stats(stats);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-stats.ts